<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useI18n } from 'vue-i18n';
import { CONTENT_TYPES } from '../constants.js';
import { useMessageContext } from '../provider.js';
import { useInbox } from 'dashboard/composables/useInbox';

const { content, contentAttributes, contentType } = useMessageContext();
const { t } = useI18n();
const { isAWebWidgetInbox } = useInbox();

const isEmail = value => {
  if (!value) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
};

const formValues = computed(() => {
  if (contentType.value === CONTENT_TYPES.FORM) {
    const { items, submittedValues = [] } = contentAttributes.value;

    if (submittedValues.length) {
      return submittedValues.map(submittedValue => {
        const item = items.find(
          formItem => formItem.name === submittedValue.name
        );
        return {
          title: submittedValue.value,
          value: submittedValue.value,
          label: item?.label,
        };
      });
    }

    return [];
  }

  if (contentType.value === CONTENT_TYPES.INPUT_SELECT) {
    const [item] = contentAttributes.value?.submittedValues ?? [];
    if (!item) return [];

    return [
      {
        title: item.title,
        value: item.value,
        label: '',
      },
    ];
  }

  return [];
});
</script>

<template>
  <BaseBubble
    class="wlab-form-bubble px-5 py-5"
    data-bubble-name="form"
    data-testid="chat-survey-panel"
  >
    <p class="wlab-form-bubble__title">
      <span v-dompurify-html="content || t('CONTACT.PRE_CHAT')" />
    </p>

    <div class="privacy-masker">
      <div v-if="formValues.length" class="wlab-form-bubble__rows">
        <div
          v-for="(item, idx) in formValues"
          :key="`${item.title}-${idx}`"
          class="wlab-form-bubble__row"
        >
          <p class="wlab-form-bubble__question">
            {{ (item.label || t('CONVERSATION.RESPONSE')) + ':' }}
          </p>
          <div class="wlab-form-bubble__answer">
            <a
              v-if="isEmail(item.title)"
              :href="`mailto:${item.title}`"
              target="_blank"
              rel="noopener noreferrer"
              tabindex="0"
            >
              <span>{{ item.title }}</span>
            </a>
            <span v-else>{{ item.title }}</span>
          </div>
        </div>
      </div>
      <div v-else-if="isAWebWidgetInbox" class="wlab-form-bubble__empty">
        {{ t('CONVERSATION.NO_RESPONSE') }}
      </div>
    </div>
  </BaseBubble>
</template>
